import React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import Course from 'components/organisms/Course/Course';

export default function StartCourse() {
  document.body.style.overflow = '';

  return (
    <Routes>
      <Route path="/:courseId" element={<Navigate to="forms" />} />
      <Route path=":courseId/:tab" element={<Course />} />
    </Routes>
  );
}
